
<div class="row" *ngIf="productInfoError || productInfo">
    <div class="col-12">

        <!-- title -->
        <div class="title">
            <h5> Вы действительно хотите удалить выбранные атрибуты? </h5>
        </div>

        <!-- content -->
        <div class="content">

            <!-- errors -->
            <div class="errors" *ngIf="productInfoError.message == 'ERROR'">
                <span> {{ productInfoError.result }} </span>
            </div>

            <!-- info -->
            <div class="info">
                <ul *ngFor="let info of productInfo">
                    <li> Данный атрибут <b>{{ info.name }}</b> используется в {{ info.count }} товар(ах) </li>
                </ul>
            </div>

        </div>

        <!-- buttons -->
        <div class="buttons">

            <!-- close -->
            <button type="button" class="btn btn-light" (click)="close()">
                Закрыть
            </button>

            <!-- delete -->
            <button type="button" class="btn btn-primary" (click)="delete()" [disabled]="productInfoError.message == 'ERROR'">
                Удалить
            </button>

        </div>

    </div>
</div>